export default "__VITE_ASSET__B2CoZUU4__"